export default {
  home: {
    meta: {
      title: "AllChinaBuy Spreadsheet 2026: Finds, Guides & Resources",
      description:
        "Explore the latest AllChinaBuy spreadsheet, product finds, buying guides, shipping tips, QC information and related resources in one organized hub.",
      keywords:
        "AllChinaBuy spreadsheet, AllChinaBuy finds, AllChinaBuy guide, AllChinaBuy review",
    },
    hero: {
      badge: "Updated for 2026 · Multilingual · Built for shoppers",
      title: "AllChinaBuy Spreadsheet",
      titleAccent: "— Discover Better Finds & Guides",
      subtitle:
        "Looking for the latest AllChinaBuy spreadsheet? Explore organized product finds, buying guides, QC information, shipping tips and related resources — all in one simple, searchable hub.",
      ctaPrimary: "Explore AllChinaBuy Spreadsheet",
      ctaSecondary: "Buy It Now",
      trust: "Independent resource · Updated regularly · Multilingual",
      mockup: {
        label: "Spreadsheet Preview",
        header: "Category",
        headerProduct: "Product",
        headerResource: "Resource",
        headerQc: "QC",
        headerUpdated: "Updated",
        row1: "Shoes",
        row1Product: "Sneakers",
        row1Qc: "Yes",
        row2: "Hoodies",
        row2Product: "Crewneck",
        row2Qc: "Yes",
        row3: "Bags",
        row3Product: "Tote",
        row3Qc: "Yes",
        row4: "Accessories",
        row4Product: "Watch",
        row4Qc: "Review",
      },
    },
    categories: {
      title: "Browse by Category",
      subtitle:
        "Pick a category from the dropdown or the cards below to jump straight to the matching selection on the main website.",
      dropdownLabel: "Choose a category",
      dropdownPlaceholder: "Select a category to continue",
      dropdownCta: "Go to category",
      gridTitle: "Popular Product Categories",
      gridSubtitle: "Tap any category to explore curated finds on the main site.",
      allExternal: "All categories open in a new tab.",
    },
    about: {
      title: "Everything You Need to Explore AllChinaBuy",
      subtitle:
        "Find the information you need before browsing, comparing or purchasing — organized so you can move faster.",
      p1: "An AllChinaBuy spreadsheet is a simple, organized way to keep track of product finds, seller notes, QC results and shipping details in one place. Instead of scrolling endlessly through search results, shoppers use a spreadsheet to collect links, compare options and plan their next order with a clear overview.",
      p2: "This hub brings together the most useful resources around the AllChinaBuy spreadsheet — from category shortcuts and buying guides to shipping and QC information — so you can spend less time searching and more time finding pieces you actually want.",
      points: {
        organized: {
          title: "Organized finds",
          desc: "Collect products and links in one clear, searchable view.",
        },
        compare: {
          title: "Easy comparison",
          desc: "Compare items side by side before you commit to a purchase.",
        },
        updated: {
          title: "Always current",
          desc: "Follow guides and resources that are refreshed regularly.",
        },
      },
    },
    guides: {
      title: "Explore the Resource Center",
      subtitle: "Guides that help you shop smarter with AllChinaBuy.",
      cards: {
        spreadsheet: {
          title: "AllChinaBuy Spreadsheet",
          desc: "Explore organized spreadsheet resources and product categories.",
        },
        finds: {
          title: "Popular Finds",
          desc: "Discover popular product categories and useful resources.",
        },
        shipping: {
          title: "Shipping Guide",
          desc: "Understand shipping methods, costs and key considerations.",
        },
        qc: {
          title: "QC Guide",
          desc: "Learn how to review product quality before purchasing.",
        },
        review: {
          title: "AllChinaBuy Review",
          desc: "Explore features, advantages, limitations and what to know.",
        },
        safety: {
          title: "Safety Center",
          desc: "Seller checks, payment safety, product risks and shipping.",
        },
      },
      cta: "Explore the Resource Center",
    },
    article: {
      title: "Latest Guides",
      subtitle: "Fresh, original articles written to help you shop smarter.",
      cardTitle: "AllChinaBuy Spreadsheet: The Complete Guide",
      cardDesc:
        "Learn what an AllChinaBuy spreadsheet is, how to use it, which categories to explore and the tips that help you find better products faster.",
      tag: "Complete Guide",
      readMore: "Read the full guide",
      updated: "Last updated",
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Quick answers to the most common questions about the AllChinaBuy spreadsheet.",
      q1: "What is an AllChinaBuy spreadsheet?",
      a1: "An AllChinaBuy spreadsheet is an organized resource that lists product finds, categories, seller notes and QC details so shoppers can browse and compare options in one place.",
      q2: "How do I use an AllChinaBuy spreadsheet?",
      a2: "Pick a category, browse the linked finds, and use the notes to compare products before opening the main website to complete your purchase.",
      q3: "Is AllChinaBuy legit?",
      a3: "AllChinaBuy is a buying platform, but you should always evaluate products, sellers, payment methods and shipping options yourself before making a decision.",
      q4: "Is AllChinaBuy safe?",
      a4: "Safety depends on how you use any buying service. Review seller information, QC photos and payment options carefully before ordering.",
      q5: "How much does AllChinaBuy shipping cost?",
      a5: "Shipping costs vary by destination, weight and method, so it is best to check current rates directly on the main website for an accurate estimate.",
      q6: "Does AllChinaBuy have coupons?",
      a6: "Promotions and discounts change over time. Visit the main website to see what offers are currently available.",
      q7: "What is the AllChinaBuy warehouse?",
      a7: "The warehouse is where purchased items are received, stored, photographed for QC and prepared for international shipping to the buyer.",
      q8: "How does AllChinaBuy QC work?",
      a8: "QC lets you request inspection photos of your items before shipping so you can confirm quality and catch issues early.",
    },
    finalCta: {
      title: "Ready to Explore AllChinaBuy Resources?",
      subtitle:
        "Start with the AllChinaBuy spreadsheet and discover the guides, finds and resources that matter most.",
      primary: "Explore AllChinaBuy Spreadsheet",
      secondary: "Visit Main Website",
    },
  },
};